const translations = {
    applyType: 'Apply',
    boundariesWord: 'boundaries',
    boundaryCount: '{{count}} boundaries',
    cancel: 'Cancel',
    cascadedWord: 'cascaded',
    checkItemsHint: 'Check items on the left to preview them here',
    clientCountSummary: '{{farms}} farms · {{fields}} fields',
    clientsWord: 'clients',
    confirmOrgSwitchBody: 'Switching organizations will clear your current selection. Continue?',
    confirmOrgSwitchTitle: 'Switch organization?',
    couldntCheckImportedWarning:
        'Could not check which items are already imported — showing all as new',
    couldntLoadData: 'Could not load John Deere data',
    discardAndSwitch: 'Discard and switch',
    errorsWord: 'errors',
    farmsWord: 'farms',
    fieldCount: '{{count}} fields',
    fieldsWord: 'fields',
    importButton: 'Import',
    importFailedWord: 'failed',
    importNItems: 'Import {{count}} items',
    importedBadge: 'Imported',
    importedWord: 'imported',
    importingNofM: 'Importing {{current}} of {{total}}…',
    keepSelection: 'Keep selection',
    loading: 'Loading John Deere data…',
    noApplyType: 'No-Apply',
    noEntryType: 'No-Entry',
    noFieldsFound: 'No fields found in this organization',
    noItemsSelected: 'No items selected',
    organizationLabel: 'Organization',
    retry: 'Retry',
    reviewImportSubtitle: 'Importing {{summary}} into SVM',
    reviewImportTitle: 'Review import from John Deere',
    selectionSummary:
        '{{clients}} clients · {{farms}} farms · {{fields}} fields · {{boundaries}} boundaries selected ({{area}} ha)',
    skippedWord: 'skipped',
    splitViewSplitTab: 'Split',
    splitViewTableTab: 'Table'
};

export default translations;
